module.exports = __webpack_public_path__ + "img/1722566409055-WhatsApp Image 2024-08-02 at 10.38.36.jpeg.8a77d9ab.webp";